import React, { useCallback, useMemo } from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import useStyles from './styles';
import { Filter } from '../../../../../types/main';
import { StringListsItem } from '../../../../../types/items';
import { addOrRemoveFilterWithArrayValue } from '../../utils';

export type CheckboxItem = {
  key: string | number;
  label: string;
  value: boolean;
  onClick?: () => void;
};

type Props = {
  filterName: string;
  filtersState: Filter[];
  updateFiltersState: (filters: Filter[]) => void;
  list: StringListsItem[];
  title: string;
};


const CheckList = ({
  title,
  filtersState,
  updateFiltersState,
  list,
  filterName,
}: Props) => {
  const classes = useStyles();

  const updateFilterByCheckboxes = useCallback((fName: string, fValue: string) => {
    const newFiltersState = addOrRemoveFilterWithArrayValue(filtersState, fName, fValue);
    updateFiltersState(newFiltersState);
  }, [updateFiltersState, filtersState]);

  const statusFilter: Filter = useMemo(() => {
    const filterFromArray: Filter | undefined = filtersState.find((filter) => (filter.key === filterName));
    return filterFromArray || { key: filterName, value: [] };
  }, [filtersState, filterName]);

  const checkboxItems: CheckboxItem[] = list?.map((status) => ({
    key: status.key,
    label: status.value,
    value: (Array.isArray(statusFilter?.value) && statusFilter.value.includes(status.key)) || false,
    onClick: () => updateFilterByCheckboxes(filterName, status.key),
  }));

  return (
    <div>
      <div>{title}</div>
      <div className={classes.list}>
        {checkboxItems.map((item) => (
          <FormControlLabel
            key={item.key}
            control={(
              <Checkbox
                checked={item.value}
                onChange={item.onClick}
                // style={{ color: '#01B3C5' }}
                classes={{ root: classes.checkbox }}
              />
            )}
            label={item.label}
            classes={{
              label: classes.label,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default CheckList;
